import React, { useState, useEffect } from 'react';
import { Loading } from 'carbon-components-react';
import styled from 'styled-components';

// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import StudyListContent from './StudyListContent';
import TileHeader from '../../components/TileHeader/TileHeader';

import NewStudyModal from './NewStudyModal';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import { toaster } from '../../helpers/toaster';
// api
import { getStudyList, deleteStudy, exportStudyData } from '../../api/studyListApi';

const StudyList = ({
  user,
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(false);

  const [studyList, setStudyList] = useState(null);
  const [openNewStudyModal, setOpenNewStudyModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  // const [openSyncModal,setOpenSyncModal] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [openExportModal, setOpenExportModal] = useState(false);

  const refreshTriggered = () => {
    setRefreshData(true);

  }

  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true);
    setDeleteItem(itemId);
  };

  const confirmDelete = () => {
    setOpenDeleteModal(false);
    setLoading(true);
    deleteStudy(deleteItem?.id).then(res => {
      // cogoToast.success("Study deleted successfully", {
			// 	heading: "Success",
			// 	position: 'bottom-right'
			// });
      setLoading(false);
      refreshTriggered();
    });
  };

  const showExportConfirm = () =>{
    setOpenExportModal(true);
  }

  const confirmExport = () => {
    setOpenExportModal(false);
    // cogoToast.success(`Exporting studies...`, {
    //   heading: "In progess",
    //   position: 'bottom-right'
    // });
    exportStudyData().then(response =>{
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.headers['fileName']); //or any other extension
      document.body.appendChild(link);
      link.click();
      // cogoToast.success(`Studies exported`, {
      //   heading: "Success",
      //   position: 'bottom-right'
      // });
    }).catch(error => {
      // cogoToast.error('Error exporting study', {
      //   heading: "Error",
      //   position: "bottom-right"
      // })
    });
  };


  return (
  <Container>
      <ContentContainer>
        <TileHeader 
            title="Studies"
            // subtitle="A list of all studies."
            size="lg"
        />

				{
					loading ? 
					<Loading

          /> 
					:
					<></>
				}

          <StudyListContent
            studyList={studyList}
            setOpenNewStudyModal={setOpenNewStudyModal}
            onDeleteClicked={showDeleteConfirm}
            // onSyncClicked={showSyncConfirm}
            onExportClicked={showExportConfirm}
            refresh={refreshData}
            setRefresh={setRefreshData}
            />

        <NewStudyModal
          open={openNewStudyModal}
          refreshStudyList={refreshTriggered}
          onClose={() => setOpenNewStudyModal(false)}
          loading={setLoading}
        />
        <ConfirmModal
          title="Delete Study"
          content={`Are you sure you want to delete Study ${deleteItem?.org_study_id}? This will remove all locations, attachments, and registries associated with it.`}
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          onConfirm={() => confirmDelete()}
        />
        <ConfirmModal
          title="Export Study Data"
          content="Do you want to export study data? This may take awhile."
          open={openExportModal}
          onClose={() => setOpenExportModal(false)}
          onConfirm={() => confirmExport()}
        />

      </ContentContainer>
    </Container>
  );
};

export default StudyList;